import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

export const selectedBorderWidth = 2;
export const selectedBorder = `${selectedBorderWidth}px solid ${colors.B100}`;

export const invisibleBorder = `${selectedBorderWidth}px solid transparent`;

export const tableBorderRadius = '3px'; // same radius as the Atlaskit input fields

export const DatabaseValueViewContainer = styled.span`
  display: inline-flex;
  max-width: 100%;
  flex-wrap: wrap;
`;
